export default function noop() {
  return new Promise(resolve => setTimeout(resolve));
}
